import { Modal } from 'react-bootstrap';

export const ErrorFallback = (): React.ReactElement<any, any> => {
    return (
        <Modal show={true} animation={false} className='border-danger'>
            <h2 className='d-block p-3'>An Unexpected error occurred.</h2>
        </Modal>
    );
};
